import * as React from 'react';
export function cloneElement(element) {
  if (!React.isValidElement(element)) return element;

  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restArgs[_key - 1] = arguments[_key];
  }

  return React.cloneElement.apply(React, [element].concat(restArgs));
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/reactNode.js
// module id = 812
// module chunks = 14